import { Navigate, useSearchParams } from 'react-router-dom';

/** Compatibility route kept for one deployment window. */
const ExternalRegistration = () => {
  const [searchParams] = useSearchParams();
  const intentId = searchParams.get('intent') || '';
  const target = `/registration?step=1${intentId ? `&external_intent=${encodeURIComponent(intentId)}` : ''}`;

  return <Navigate to={target} replace />;
};

export default ExternalRegistration;
